import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTradingGpt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12.075 3.553a1.5 1.5 0 1 0-.75 0V6.6h.75V3.553Zm5.684-.717a.34.34 0 0 0-.359.337v.667c0 .179.14.327.317.335 2.73.148 4.924 2.362 5.082 5.094.01.177.158.316.336.316h.677a.34.34 0 0 0 .337-.358 6.767 6.767 0 0 0-6.39-6.391Zm.006 2.025a.34.34 0 0 0-.365.34v.676c0 .177.137.323.312.336 1.62.132 2.912 1.438 3.058 3.062.016.175.16.31.335.31h.68a.342.342 0 0 0 .339-.365 4.746 4.746 0 0 0-4.359-4.36ZM12.75 19.052v2.93c0 1.352 1.648 2.014 2.583 1.038l3.959-4.134a.75.75 0 1 0-1.084-1.038l-3.958 4.134v-2.93a.75.75 0 0 0-1.5 0Zm-3.075-8.064a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Zm5.625 0a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M6 6a3.75 3.75 0 0 0-3.75 3.75v6A3.75 3.75 0 0 0 6 19.5h11.25A3.75 3.75 0 0 0 21 15.75v-6A3.75 3.75 0 0 0 17.25 6H6ZM3.75 9.75A2.25 2.25 0 0 1 6 7.5h11.25a2.25 2.25 0 0 1 2.25 2.25v6A2.25 2.25 0 0 1 17.25 18H6a2.25 2.25 0 0 1-2.25-2.25v-6Zm5.061 3.407a.75.75 0 0 0-.772 1.286 6.824 6.824 0 0 0 7.022 0 .75.75 0 1 0-.772-1.286 5.324 5.324 0 0 1-5.478 0Z"
    />
  </svg>
);
export default SvgTwoColorTradingGpt;
